import Vue from 'vue'

// 名字截取
Vue.filter('namePrecise', (name, num) => {
  if (!name) return ''
  if (name.length > num) {
    return name.slice(0, num) + '...'
  }
  return name
})
